import { motion } from 'framer-motion';

const AccessMap = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-beige-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 sm:mb-12"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-3 sm:mb-4 px-4">
            アクセス
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-navy-700 px-4">
            岡山市北区○○町1-2-3
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-2xl overflow-hidden shadow-lg"
        >
          <div className="w-full h-64 sm:h-80 lg:h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.8947!2d133.9191!3d34.6617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDM5JzQyLjEiTiAxMzPCsDU1JzA4LjgiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="ヘルパーステーションおかやま 地図"
            ></iframe>
          </div>
          <div className="p-6 sm:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-xl sm:text-2xl text-coral-500 mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-navy-800 mb-1 text-sm sm:text-base">
                    所在地
                  </h3>
                  <p className="text-xs sm:text-sm text-navy-700">
                    岡山市北区○○町1-2-3
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-train-line text-xl sm:text-2xl text-coral-500 mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-navy-800 mb-1 text-sm sm:text-base">
                    最寄り駅
                  </h3>
                  <p className="text-xs sm:text-sm text-navy-700">
                    JR岡山駅より徒歩15分
                    <br />
                    バス停「○○町」より徒歩3分
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-phone-line text-xl sm:text-2xl text-coral-500 mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-navy-800 mb-1 text-sm sm:text-base">
                    電話番号
                  </h3>
                  <a
                    href="tel:086-012-3456"
                    className="text-xs sm:text-sm text-coral-600 hover:text-coral-700 cursor-pointer"
                  >
                    086-012-3456
                  </a>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-time-line text-xl sm:text-2xl text-coral-500 mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <h3 className="font-bold text-navy-800 mb-1 text-sm sm:text-base">
                    営業時間
                  </h3>
                  <p className="text-xs sm:text-sm text-navy-700">
                    9:00 〜 18:00
                    <br />
                    定休日：日曜日・祝日
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AccessMap;